class Header {
  constructor(el) {
    this.el = el;
    this.$header = $('.' + this.el);
    this.$menu = this.$header.find('.js-header-menu');
    this.$drawer = this.$header.find('.js-header-drawer');

    if (this.$header.length > 0) {
      this.event();
    }
  }

  event() {
    const threshold = 100;
    let scrollTimer;

    // スクロール時のヘッダー固定表示（メニュー開閉の scrollBan とは別）
    const updateHeaderFixed = () => {
      if (this.$header.hasClass('is-active')) return;
      this.$header.toggleClass('is-fixed', $(window).scrollTop() > threshold);
    };

    const syncAria = () => {
      const open = this.$header.hasClass('is-active');
      this.$drawer.attr('aria-hidden', open ? 'false' : 'true');
      this.$menu.attr({
        'aria-expanded': open ? 'true' : 'false',
        'aria-label': open ? 'メニューを閉じる' : 'メニューを開く',
      });
    };

    // ドロワー内だけ縦スクロール可、背面のタッチスクロールを止める
    let scrollLocked = false;

    const onTouchMove = (e) => {
      if ($(e.target).closest('.l-header__drawer-inner').length) return;
      e.preventDefault();
    };

    // scrollBan: スクロールバー幅を補償して開閉時の横ガタつきを防ぐ
    const lockBody = () => {
      if (scrollLocked) return;
      scrollLocked = true;
      scrollBanOpen();
      document.addEventListener('touchmove', onTouchMove, { passive: false });
    };

    const unlockBody = () => {
      if (!scrollLocked) return;
      scrollLocked = false;
      scrollBanClose();
      document.removeEventListener('touchmove', onTouchMove);
    };

    // 開閉の核: .l-header.is-active + scrollBan
    const toggleMenu = () => {
      const willOpen = !this.$header.hasClass('is-active');

      if (willOpen) {
        lockBody();
        this.$header.addClass('is-active');
        syncAria();
      } else {
        this.$header.removeClass('is-active');
        unlockBody();
        syncAria();
        updateHeaderFixed();
      }
    };

    const closeMenu = () => {
      if (!this.$header.hasClass('is-active')) return;
      this.$header.removeClass('is-active');
      unlockBody();
      syncAria();
      updateHeaderFixed();
    };

    updateHeaderFixed();

    $(window).on('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateHeaderFixed, 50);
    });

    this.$menu.on('click', (e) => {
      e.stopPropagation();
      toggleMenu();
    });
    this.$header.find('.js-header-nav-link').on('click', closeMenu);

    // メニュー外（背面オーバーレイ含む）クリックで閉じる
    this.$header.on('click', (e) => {
      if (!this.$header.hasClass('is-active')) return;
      if ($(e.target).closest('.js-header-menu, .l-header__drawer').length) return;
      closeMenu();
    });

    $(document).on('keydown.headerMenu', (e) => {
      if (e.key === 'Escape' && this.$header.hasClass('is-active')) {
        closeMenu();
      }
    });
  }
}
